import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ForceCompleteContentProgressMutationVariables = Types.Exact<{
  input: Types.ForceCompleteContentProgressInput;
}>;


export type ForceCompleteContentProgressMutation = { forceCompleteContentProgress: { success?: boolean | null, jobScheduleId: string } };


export const ForceCompleteContentProgressDocument = /*#__PURE__*/ gql`
    mutation forceCompleteContentProgress($input: ForceCompleteContentProgressInput!) {
  forceCompleteContentProgress(input: $input) {
    success
    jobScheduleId
  }
}
    `;

export function useForceCompleteContentProgressMutation() {
  return Urql.useMutation<ForceCompleteContentProgressMutation, ForceCompleteContentProgressMutationVariables>(ForceCompleteContentProgressDocument);
};